// extracted by mini-css-extract-plugin
export default {"reinvestHistory":"Tablisting_reinvestHistory__AVSkg","listingTitle":"Tablisting_listingTitle__utzHi","field":"Tablisting_field__McQoA","copyIcon":"Tablisting_copyIcon__rahRK"};